var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoPlayer",attrs:{"src":_vm.url,"width":"100%","height":"auto","controls":"","controlsList":"nodownload","disablePictureInPicture":"","id":"video-player","type":"mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }